/**
 * ConflictWarnings
 * Renders conflict banners: errors in red, warnings in amber.
 */
import { AlertCircle, AlertTriangle } from "lucide-react";

export interface Conflict {
  type: string;
  severity: "error" | "warning";
  message: string;
}

interface ConflictWarningsProps {
  conflicts: Conflict[];
}

export function ConflictWarnings({ conflicts }: ConflictWarningsProps) {
  if (conflicts.length === 0) return null;

  return (
    <div className="flex flex-col gap-2">
      {conflicts.map((c, i) => {
        const isError = c.severity === "error";
        return (
          <div
            key={`${c.type}-${i}`}
            className={`flex items-start gap-2 rounded-md border px-3 py-2 text-sm ${
              isError
                ? "border-red-300 bg-red-50 text-red-800 dark:border-red-800 dark:bg-red-950 dark:text-red-200"
                : "border-amber-300 bg-amber-50 text-amber-800 dark:border-amber-800 dark:bg-amber-950 dark:text-amber-200"
            }`}
            role="alert"
          >
            {isError ? (
              <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" />
            ) : (
              <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
            )}
            <span>{c.message}</span>
          </div>
        );
      })}
    </div>
  );
}
